import { ReferentialKey } from 'api/referential';
import { selectReferentialByKey } from 'features/referentials/selectors/selectReferentialByKey';
import { FC } from 'react';
import { useSelector } from 'react-redux';
import { BaseFormField } from 'types/form/baseFormField';
import { DropdownItem } from 'components/forms/Dropdown';
import { FormikDropdown } from 'components/forms/formik/FormikDropdown';

interface ReferentialDropdownProps extends BaseFormField {
  placeholder?: string;
  referentialKey: ReferentialKey;
  disabled?: boolean;
  selectedItemKey?: string;
  omitKeys?: string[]
  onChange?: (selectedItem: DropdownItem | null) => void;
}

export const ReferentialDropdown: FC<ReferentialDropdownProps> = ({
  name,
  label,
  referentialKey,
  disabled,
  required,
  placeholder,
  selectedItemKey,
  onChange,
  omitKeys
}) => {
  const referential = useSelector(selectReferentialByKey(referentialKey));
  const items = referential && referential.length > 0 ? referential : [];

  return (
    <FormikDropdown
      name={name}
      label={label}
      items={items}
      disabled={disabled}
      placeholder={placeholder}
      required={required}
      omitKeys={omitKeys}
      selectedItemKey={selectedItemKey}
      onChange={onChange}
    />
  );
};
